import styled from "styled-components";
import BeltImage from "../../../assets/images/product/belt.jpg";
import PantsImage from "../../../assets/images/product/pants.jpg";
import ShirtImage from "../../../assets/images/product/shirts.jpg";
import SweaterImage from "../../../assets/images/product/sweater.jpg";
import H2 from "../../../components/typography/H2";
import CategoryImage from "./CategoryImage";

const Wrapper = styled.div`
  width: 100%;
  margin: auto;
`;

const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(290px, 1fr));
  gap: 30px;
  width: 100%;
  justify-items: center;
  @media (max-width: 800px) {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 20px;
  }

  @media (max-width: 500px) {
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 20px;
    padding: 0px;
  }
`;

const Center = styled.div`
  padding: 35px;
  text-align: center;
`;

function CategoryWithImages() {
  return (
    <Wrapper>
      <Center>
        <H2>Shop By Category</H2>
      </Center>
      <Container>
        <CategoryImage
          categoryName={"Topwear"}
          ImageUrl={ShirtImage}
        />
        <CategoryImage
          categoryName={"Outerwear"}
          ImageUrl={SweaterImage}
        />
        <CategoryImage categoryName={"Bottomwear"} ImageUrl={PantsImage} />
        <CategoryImage
          categoryName={"Accessories"}
          ImageUrl={BeltImage}
        />
      </Container>
    </Wrapper>
  );
}

export default CategoryWithImages;
